/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.10.21",
    versionName: "0.2.0-nightly.2025.10.21",
    versionChannel: "nightly",
    buildDate: "2025-10-21T00:08:31.847Z",
    commitHash: "14faa64f34ce581b15b48293672268ea321ccf27",
};
